<ng-container
  *epcFeatureFlag="
    ContentConfigurationKeys.showPlayground;
    namespace: NAMESPACE_CONTENT;
    equality: true;
    defaultValue: false
  "
>
  <textarea
    class="w-100"
    autofocus="true"
    rows="10"
    [(ngModel)]="contentStr"
    (ngModelChange)="onChange()"
  ></textarea>

  <h6 class="mt-3" i18n="@@contentPlayGroundPreviewTitle">
    Preview (Gray area)
  </h6>
  <div [attr.id]="previewAreaId" #host></div>
</ng-container>
